import { z } from 'zod';
import { UserResponseSchema } from './users.js';

// ─── Request schemas ──────────────────────────────────────────────────────────

export const LoginRequestSchema = z.object({
  email: z.string().email().toLowerCase(),
  // PRD §16.1: passwords ≥12 chars on creation; no max length cap
  password: z.string().min(12),
});
export type LoginRequest = z.infer<typeof LoginRequestSchema>;

// ─── Response schemas ─────────────────────────────────────────────────────────

export const LoginResponseSchema = z.object({
  ok: z.literal(true),
  user: UserResponseSchema,
  accessToken: z.string().min(1),
  accessTokenExpiresAt: z.string(),
});
export type LoginResponse = z.infer<typeof LoginResponseSchema>;

export const RefreshResponseSchema = z.object({
  ok: z.literal(true),
  accessToken: z.string().min(1),
  accessTokenExpiresAt: z.string(),
});
export type RefreshResponse = z.infer<typeof RefreshResponseSchema>;

export const MeResponseSchema = z.object({
  ok: z.literal(true),
  user: UserResponseSchema,
});
export type MeResponse = z.infer<typeof MeResponseSchema>;

export const LogoutResponseSchema = z.object({
  ok: z.literal(true),
});
export type LogoutResponse = z.infer<typeof LogoutResponseSchema>;
